import {Alert, InteractionManager, Keyboard, Platform} from 'react-native';
import sanitizeUserMessage from './sanitizeUserMessage';

const IOS_KEYBOARD_DISMISS_DELAY_MS = 160;

export const dismissKeyboardThen = (
  callback: () => void,
  delayMs: number = IOS_KEYBOARD_DISMISS_DELAY_MS,
) => {
  Keyboard.dismiss();

  if (Platform.OS === 'ios') {
    setTimeout(() => {
      InteractionManager.runAfterInteractions(callback);
    }, delayMs);
    return;
  }

  InteractionManager.runAfterInteractions(callback);
};

export const showKeyboardAwareAlert = (
  title: string,
  message?: string,
  buttons?: any[],
  options?: any,
  delayMs: number = IOS_KEYBOARD_DISMISS_DELAY_MS,
) => {
  dismissKeyboardThen(() => {
    Alert.alert(title, sanitizeUserMessage(message), buttons, options);
  }, delayMs);
};
